import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom';

function RouteDetails() {
  const navigate = useNavigate();
  const location = useLocation();
  const routeDetails = location.state?.routeDetails || {};

  return (
    <div>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="page-header">
              <div className='row text-end'>
                <div className='col'>
                  <button type="button" class="btn btn-danger"
                    style={{
                      backgroundColor: "rgb(236, 17, 23)"
                    }}
                    onClick={() => navigate("/route-master")}
                  >
                    Back
                  </button>
                </div>
              </div>
              <h4 style={{ display: "flex", marginBottom: "30px" }}>
                Route Details of :  {routeDetails.route_name}
              </h4>
              <div className="card">
                <div className="p-3">
                  <div className="text-start mb-3">
                    <div className="row">
                      <div className="col-md-4 mb-3">
                        <div className="form-group">
                          <label className="form-label">Route Name</label>
                          <input
                            type="text"
                            name="route_name"
                            className="form-control"
                            readOnly
                            value={routeDetails.route_name}
                          />
                        </div>
                      </div>
                      <div className="col-md-4 mb-3">
                        <div className="form-group">
                          <label className="form-label">Route Code</label>
                          <input
                            type="text"
                            name="route_code"
                            className="form-control"
                            readOnly
                            value={routeDetails.route_code}
                          />
                        </div>
                      </div>
                      <div className="col-md-4 mb-3">
                        <div className="form-group">
                          <label className="form-label">Zone</label>
                          <input
                            type="text"
                            name="zone_name"
                            className="form-control"
                            readOnly
                            value={routeDetails.zone_name}
                          />
                        </div>
                      </div>
                      <div className="col-md-4 mb-3">
                        <div className="form-group">
                          <label className="form-label">Circle</label>
                          <input
                            type="text"
                            name="circle_name"
                            className="form-control"
                            readOnly
                            value={routeDetails.circle_name}
                          />
                        </div>
                      </div>
                      <div className="col-md-4 mb-3">
                        <div className="form-group">
                          <label className="form-label">Collection Points Data</label>
                          <div
                            style={{ height: 'auto' }}
                            className="form-control"
                            readOnly
                            name="collection_points_data"
                          >
                            {routeDetails.collection_points_data.map((point) =>
                              <>
                                <p className='mb-3'>Collection Point Name: {point.collection_point_name}</p>
                                <p className='mb-3'>Sort Order : {point.sort_order}</p>
                              </>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="col-md-4 mb-3">
                        <div className="form-group">
                          <label className="form-label">Status</label>
                          <input
                            type="text"
                            className="form-control"
                            name="status"
                            readOnly
                            value={routeDetails.status === "1" ? "Active" : "Inactive"}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RouteDetails
